// enquiry context constants
export const GET_ENQUIRY_BEGIN = "GET_ENQUIRY_BEGIN";
export const GET_ENQUIRY_SUCCESS = "GET_ENQUIRY_SUCCESS";
export const GET_ENQUIRY_FAILURE = "GET_ENQUIRY_FAILURE";
export const ADD_ENQUIRY_BEGIN = "ADD_ENQUIRY_BEGIN";
export const ADD_ENQUIRY_SUCCESS = "ADD_ENQUIRY_SUCCESS";
export const ADD_ENQUIRY_FAILURE = "ADD_ENQUIRY_FAILURE";

// testimonial context constants
export const GET_TESTIMONIAL_BEGIN = "GET_TESTIMONIAL_BEGIN";
export const GET_TESTIMONIAL_SUCCESS = "GET_TESTIMONIAL_SUCCESS";
export const GET_TESTIMONIAL_FAILURE = "GET_TESTIMONIAL_FAILURE";
export const ADD_TESTIMONIAL_BEGIN = "ADD_TESTIMONIAL_BEGIN";
export const ADD_TESTIMONIAL_SUCCESS = "ADD_TESTIMONIAL_SUCCESS";
export const ADD_TESTIMONIAL_FAILURE = "ADD_TESTIMONIAL_FAILURE";

// blog context constants
export const GET_BLOG_BEGIN = "GET_BLOG_BEGIN";
export const GET_BLOG_SUCCESS = "GET_BLOG_SUCCESS";
export const GET_BLOG_FAILURE = "GET_BLOG_FAILURE";
export const GLOBAL_SEARCH_BLOG_SUCCESS = " GLOBAL_SEARCH_BLOG_SUCCESS";
export const GLOBAL_SEARCH_BLOG_FAILURE = "GLOBAL_SEARCH_BLOG_FAILURE";

export const PUT_BLOG_LIKES_BEGIN = "PUT_BLOG_LIKES_BEGIN";
export const PUT_BLOG_LIKES_SUCCESS = "PUT_BLOG_LIKES_SUCCESS";
export const PUT_BLOG_LIKES_FAILURE = "PUT_BLOG_LIKES_FAILURE";

export const GET_BLOG_COMMENTS_BEGIN = "GET_BLOG_BEGIN";
export const GET_BLOG_COMMENTS_SUCCESS = "GET_BLOG_COMMENTS_SUCCESS";
export const GET_BLOG_COMMENTS_FAILURE = "GET_BLOG_COMMENTS_FAILURE";

export const ADD_BLOG_COMMENTS_BEGIN = "ADD_BLOG_COMMENTS_BEGIN";
export const ADD_BLOG_COMMENTS_SUCCESS = "ADD_BLOG_COMMENTS_SUCCESS";
export const ADD_BLOG_COMMENTS_FAILURE = "ADD_BLOG_COMMENTS_FAILURE";

export const UPDATE_BLOG_COMMENTS_BEGIN = "UPDATE_BLOG_COMMENTS_BEGIN";
export const UPDATE_BLOG_COMMENTS_SUCCESS = "UPDATE_BLOG_COMMENTS_SUCCESS";
export const UPDATE_BLOG_COMMENTS_FAILURE = "UPDATE_BLOG_COMMENTS_FAILURE";

export const DELETE_BLOG_COMMENTS_BEGIN = "DELETE_BLOG_COMMENTS_BEGIN";
export const DELETE_BLOG_COMMENTS_SUCCESS = "DELETE_BLOG_COMMENTS_SUCCESS";
export const DELETE_BLOG_COMMENTS_FAILURE = "DELETE_BLOG_COMMENTS_FAILURE";

// domain context constants
export const GET_DOMAIN_BEGIN = "GET_DOMAIN_BEGIN";
export const GET_DOMAIN_SUCCESS = "GET_DOMAIN_SUCCESS";
export const GET_DOMAIN_FAILURE = "GET_DOMAIN_FAILURE";

// filter context constants
export const LOAD_COURSES = "LOAD_COURSES";
export const UPDATE_SORT = "UPDATE_SORT";
export const UPDATE_SEARCH = "UPDATE_SEARCH";
export const SEARCH_COURSES = "SEARCH_COURSES";
export const UPDATE_FILTERS = "UPDATE_FILTERS";
export const FILTER_COURSES = "FILTER_COURSES";
export const CLEAR_FILTERS = "CLEAR_FILTERS";

// instructor context constants
export const GET_INSTRUCTOR_BEGIN = "GET_INSTRUCTOR_BEGIN";
export const GET_INSTRUCTOR_SUCCESS = "GET_INSTRUCTOR_SUCCESS";
export const GET_INSTRUCTOR_FAILURE = "GET_INSTRUCTOR_FAILURE";

//login context constants
export const GET_LOGIN_BEGIN = "GET_LOGIN_BEGIN";
export const GET_LOGIN_SUCCESS = "GET_LOGIN_SUCCESS";
export const GET_LOGIN_FAILURE = "GET_LOGIN_FAILURE";

export const GET_LOGIN_STATUS_BEGIN = "GET_LOGIN_STATUS_BEGIN";
export const GET_LOGIN_STATUS_SUCCESS = "GET_LOGIN_STATUS_SUCCESS";
export const GET_LOGIN_STATUS_FAILURE = "GET_LOGIN_STATUS_FAILURE";

//logout context constants
export const GET_SIGNOUT_BEGIN = "GET_SIGNOUT_BEGIN";
export const GET_SIGNOUT_SUCCESS = "GET_SIGNOUT_SUCCESS";
export const GET_SIGNOUT_FAILURE = "GET_SIGNOUT_FAILURE";

// signup context constants
export const GET_SIGNUP_BEGIN = "GET_SIGNUP_BEGIN";
export const GET_SIGNUP_SUCCESS = "GET_SIGNUP_SUCCESS";
export const GET_SIGNUP_FAILURE = "GET_SIGNUP_FAILURE";

// forgot-password context constants
export const POST_FORGOT_PASSWORD_BEGIN = "POST_FORGOT_PASSWORD_BEGIN";
export const POST_FORGOT_PASSWORD_SUCCESS = "POST_FORGOT_PASSWORD_SUCCESS";
export const POST_FORGOT_PASSWORD_FAILURE = "POST_FORGOT_PASSWORD_FAILURE";

// reset-password context constants
export const POST_RESET_PASSWORD_BEGIN = "POST_RESET_PASSWORD_BEGIN";
export const POST_RESET_PASSWORD_SUCCESS = "POST_RESET_PASSWORD_SUCCESS";
export const POST_RESET_PASSWORD_FAILURE = "POST_RESET_PASSWORD_FAILURE";

// username-availability context constants
export const CHECK_USERNAME_AVAILABILITY_BEGIN = "CHECK_USERNAME_AVAILABILITY_BEGIN";
export const CHECK_USERNAME_AVAILABILITY_SUCCESS = "CHECK_USERNAME_AVAILABILITY_SUCCESS";
export const CHECK_USERNAME_AVAILABILITY_FAILURE = "CHECK_USERNAME_AVAILABILITY_FAILURE";

// User-profile update
export const UPDATE_USER_PROFILE_BEGIN = "UPDATE_USER_PROFILE_BEGIN";
export const UPDATE_USER_PROFILE_SUCCESS = "UPDATE_USER_PROFILE_SUCCESS";
export const UPDATE_USER_PROFILE_FAILURE = "UPDATE_USER_PROFILE_FAILURE";

// youtube context constants
export const GET_YOUTUBE_CHANNEL_DATA_BEGIN = "GET_YOUTUBE_CHANNEL_DATA_BEGIN";
export const GET_YOUTUBE_CHANNEL_DATA_SUCCESS =
  "GET_YOUTUBE_CHANNEL_DATA_SUCCESS";
export const GET_YOUTUBE_CHANNEL_DATA_FAILURE =
  "GET_YOUTUBE_CHANNEL_DATA_FAILURE";

export const GET_YOUTUBE_LATEST_VIDEO_BEGIN = "GET_YOUTUBE_LATEST_VIDEO_BEGIN";
export const GET_YOUTUBE_LATEST_VIDEO_SUCCESS =
  "GET_YOUTUBE_LATEST_VIDEO_SUCCESS";
export const GET_YOUTUBE_LATEST_VIDEO_FAILURE =
  "GET_YOUTUBE_LATEST_VIDEO_FAILURE";

export const GET_YOUTUBE_VIDEO_CATEGORIES_BEGIN =
  "GET_YOUTUBE_VIDEO_CATEGORIES_BEGIN";
export const GET_YOUTUBE_VIDEO_CATEGORIES_SUCCESS =
  "GET_YOUTUBE_VIDEO_CATEGORIES_SUCCESS";
export const GET_YOUTUBE_VIDEO_CATEGORIES_FAILURE =
  "GET_YOUTUBE_VIDEO_CATEGORIES_FAILURE";

// courses context constants
export const GET_COURSES_BEGIN = "GET_COURSES_BEGIN";
export const GET_COURSES_SUCCESS = "GET_COURSES_SUCCESS";
export const GET_COURSES_FAILURE = "GET_COURSES_FAILURE";

// course comments context constants
export const GET_COURSE_COMMENT_BEGIN = "GET_COURSE_COMMENT_BEGIN";
export const GET_COURSE_COMMENT_SUCCESS = "GET_COURSE_COMMENT_SUCCESS";
export const GET_COURSE_COMMENT_FAILURE = "GET_COURSE_COMMENT_FAILURE";

export const PUT_COURSE_LIKES_BEGIN = "PUT_COURSE_LIKES_BEGIN";
export const PUT_COURSE_LIKES_SUCCESS = "PUT_COURSE_LIKES_SUCCESS";
export const PUT_COURSE_LIKES_FAILURE = "PUT_COURSE_LIKES_FAILURE";

export const ADD_COURSE_COMMENT_BEGIN = "ADD_COURSE_COMMENT_BEGIN";
export const ADD_COURSE_COMMENT_SUCCESS = "ADD_COURSE_COMMENT_SUCCESS";
export const ADD_COURSE_COMMENT_FAILURE = "ADD_COURSE_COMMENT_FAILURE";

export const UPDATE_COURSE_COMMENT_BEGIN = "UPDATE_COURSE_COMMENT_BEGIN";
export const UPDATE_COURSE_COMMENT_SUCCESS = "UPDATE_COURSE_COMMENT_SUCCESS";
export const UPDATE_COURSE_COMMENT_FAILURE = "UPDATE_COURSE_COMMENT_FAILURE";

export const DELETE_COURSE_COMMENT_BEGIN = "DELETE_COURSE_COMMENT_BEGIN";
export const DELETE_COURSE_COMMENT_SUCCESS = "DELETE_COURSE_COMMENT_SUCCESS";
export const DELETE_COURSE_COMMENT_FAILURE = "DELETE_COURSE_COMMENT_FAILURE";

// global search constants
export const GLOBAL_SEARCH_COURSES_SUCCESS = "GLOBAL_SEARCH_COURSES_SUCCESS";
export const GLOBAL_SEARCH_COURSES_FAILURE = "GLOBAL_SEARCH_COURSES_FAILURE";

// user reaction constants
export const SET_USER_REACTION_BEGIN = "SET_USER_REACTION_BEGIN";
export const SET_USER_REACTION_SUCCESS = "SET_USER_REACTION_SUCCESS";
export const SET_USER_REACTION_FAILURE = "SET_USER_REACTION_FAILURE";

// course user reaction constants
export const GET_COURSE_USER_REACTION_BEIGN = "GET_COURSE_USER_REACTION_BEIGN";
export const GET_COURSE_USER_REACTION_SUCCESS = "GET_COURSE_USER_REACTION_SUCCESS";
export const GET_COURSE_USER_REACTION_FAILURE = "GET_COURSE_USER_REACTION_FAILURE";

// course user reaction constants
export const GET_BLOG_USER_REACTION_BEIGN = "GET_BLOG_USER_REACTION_BEIGN";
export const GET_BLOG_USER_REACTION_SUCCESS = "GET_BLOG_USER_REACTION_SUCCESS";
export const GET_BLOG_USER_REACTION_FAILURE = "GET_BLOG_USER_REACTION_FAILURE";

// user reaction constants
export const SET_BLOG_USER_REACTION_BEGIN = "SET_BLOG_USER_REACTION_BEGIN";
export const SET_BLOG_USER_REACTION_SUCCESS = "SET_BLOG_USER_REACTION_SUCCESS";
export const SET_BLOG_USER_REACTION_FAILURE = "SET_BLOG_USER_REACTION_FAILURE";


// categories context constants
export const GET_CATEGORIES_BEGIN = "GET_CATEGORIES_BEGIN";
export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";
export const GET_CATEGORIES_FAILURE = "GET_CATEGORIES_FAILURE";

// order context constants
export const GET_ALL_ORDERS_BEGIN = "GET_ALL_ORDERS_BEGIN";
export const GET_ALL_ORDERS_SUCCESS = "GET_ALL_ORDERS_SUCCESS";
export const GET_ALL_ORDERS_FAILURE = "GET_ALL_ORDERS_FAILURE";

export const GET_ORDERS_BEGIN = "GET_ORDERS_BEGIN";
export const GET_ORDERS_SUCCESS = "GET_ORDERS_SUCCESS";
export const GET_ORDERS_FAILURE = "GET_ORDERS_FAILURE";

// create order constants
export const CREATE_ORDERS_BEGIN = "CREATE_ORDERS_BEGIN";
export const CREATE_ORDERS_SUCCESS = "CREATE_ORDERS_SUCCESS";
export const CREATE_ORDERS_FAILURE = "CREATE_ORDERS_FAILURE";

// product context constants
export const GET_PRODUCTS_BEGIN = "GET_PRODUCTS_BEGIN";
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";
export const GET_PRODUCTS_FAILURE = "GET_PRODUCTS_FAILURE";

export const GLOBAL_SEARCH_EBOOK_SUCCESS = " GLOBAL_SEARCH_EBOOK_SUCCESS";
export const GLOBAL_SEARCH_EBOOK_FAILURE = "GLOBAL_SEARCH_EBOOK_FAILURE";

// create product constants
export const CREATE_PRODUCTS_BEGIN = "CREATE_PRODUCTS_BEGIN";
export const CREATE_PRODUCTS_SUCCESS = "CREATE_PRODUCTS_SUCCESS";
export const CREATE_PRODUCTS_FAILURE = "CREATE_PRODUCTS_FAILURE";

// Download eBook constants
export const DOWNLOAD_EBOOK_BEGIN = "DOWNLOAD_EBOOK_BEGIN";
export const DOWNLOAD_EBOOK_SUCCESS = "DOWNLOAD_EBOOK_SUCCESS";
export const DOWNLOAD_EBOOK_FAILURE = "DOWNLOAD_EBOOK_FAILURE";

// Payment success modal constants
export const CLOSE_PAYMENT_SUCCESS_MODAL = "CLOSE_PAYMENT_SUCCESS_MODAL";

// Update Download count eBook constants
export const UPDATE_DOWNLOADS_ON_ENTITY_BEGIN = "UPDATE_DOWNLOADS_ON_ENTITY_BEGIN";
export const UPDATE_DOWNLOADS_ON_ENTITY_SUCCESS = "UPDATE_DOWNLOADS_ON_ENTITY_SUCCESS";
export const UPDATE_DOWNLOADS_ON_ENTITY_FAILURE = "UPDATE_DOWNLOADS_ON_ENTITY_FAILURE";

// stat context constants
export const GET_STATS_BEGIN = "GET_STATS_BEGIN";
export const GET_STATS_SUCCESS = "GET_STATS_SUCCESS";
export const GET_STATS_FAILURE = "GET_STATS_FAILURE";

// stat context constants
export const GET_FILTERED_STATS_BEGIN = "GET_FILTERED_STATS_BEGIN";
export const GET_FILTERED_STATS_SUCCESS = "GET_FILTERED_STATS_SUCCESS";
export const GET_FILTERED_STATS_FAILURE = "GET_FILTERED_STATS_FAILURE";

// yout constants
export const GET_GALLERY_DATA_BEGIN = "GET_GALLERY_DATA_BEGIN";
export const GET_GALLERY_DATA_SUCCESS = "GET_GALLERY_DATA_SUCCESS";
export const GET_GALLERY_DATA_FAILURE = "GET_GALLERY_DATA_FAILURE";

export const GET_POPULAR_VIDEO_BEGIN = "GET_POPULAR_VIDEO_BEGIN";
export const GET_POPULAR_VIDEO_SUCCESS = "GET_POPULAR_VIDEO_SUCCESS";
export const GET_POPULAR_VIDEO_FAILURE = "GET_POPULAR_VIDEO_FAILURE";

export const GET_POPULAR_SHORTS_BEGIN = "GET_POPULAR_SHORTS_BEGIN";
export const GET_POPULAR_SHORTS_SUCCESS = "GET_POPULAR_SHORTS_SUCCESS";
export const GET_POPULAR_SHORTS_FAILURE = "GET_POPULAR_SHORTS_FAILURE";

export const GET_POPULAR_LIVE_VIDEO_BEGIN = "GET_POPULAR_LIVE_VIDEO_BEGIN";
export const GET_POPULAR_LIVE_VIDEO_SUCCESS = "GET_POPULAR_LIVE_VIDEO_SUCCESS";
export const GET_POPULAR_LIVE_VIDEO_FAILURE = "GET_POPULAR_LIVE_VIDEO_FAILURE";

export const GET_LAST_TWO_WEEK_TRENDING_VIDEOS_BEGIN = "GET_LAST_TWO_WEEK_TRENDING_VIDEOS_BEGIN";
export const GET_LAST_TWO_WEEK_TRENDING_VIDEOS_SUCCESS = "GET_LAST_TWO_WEEK_TRENDING_VIDEOS_SUCCESS";
export const GET_LAST_TWO_WEEK_TRENDING_VIDEOS_FAILURE = "GET_LAST_TWO_WEEK_TRENDING_VIDEOS_FAILURE";

export const GET_LATEST_VIDEO_BEGIN = "GET_LATEST_VIDEO_BEGIN";
export const GET_LATEST_VIDEO_SUCCESS = "GET_LATEST_VIDEO_SUCCESS";
export const GET_LATEST_VIDEO_FAILURE = "GET_LATEST_VIDEO_FAILURE";

// Quick Insights Constants
export const GET_QUICK_INSIGHTS_BEGIN = "GET_QUICK_INSIGHTS_BEGIN";
export const GET_QUICK_INSIGHTS_SUCCESS = "GET_QUICK_INSIGHTS_SUCCESS";
export const GET_QUICK_INSIGHTS_FAILURE = "GET_QUICK_INSIGHTS_FAILURE";

export const UPSERT_QUICK_INSIGHTS_USER_INTERACTION_BEGIN = "UPSERT_QUICK_INSIGHTS_USER_INTERACTION_BEGIN";
export const UPSERT_QUICK_INSIGHTS_USER_INTERACTION_SUCCESS = "UPSERT_QUICK_INSIGHTS_USER_INTERACTION_SUCCESS";
export const UPSERT_QUICK_INSIGHTS_USER_INTERACTION_FAILURE = "UPSERT_QUICK_INSIGHTS_USER_INTERACTION_FAILURE";

export const GET_USER_INTERACTION_BY_INSIGHTS_BEGIN = "GET_USER_INTERACTION_BY_INSIGHTS_BEGIN";
export const GET_USER_INTERACTION_BY_INSIGHTS_SUCCESS = "GET_USER_INTERACTION_BY_INSIGHTS_SUCCESS";
export const GET_USER_INTERACTION_BY_INSIGHTS_FAILURE = "GET_USER_INTERACTION_BY_SERIES_FAILURE";

export const GET_ALL_INSIGHTS_USER_INTERACTION_BEGIN = "GET_ALL_INSIGHTS_USER_INTERACTION_BEGIN";
export const GET_ALL_INSIGHTS_USER_INTERACTION_SUCCESS = "GET_ALL_INSIGHTS_USER_INTERACTION_SUCCESS";
export const GET_ALL_INSIGHTS_USER_INTERACTION_FAILURE = "GET_ALL_INSIGHTS_USER_INTERACTION_FAILURE";

// interview constants
export const GET_INTERVIEW_CATEGORIES_DATA_BEGIN = "GET_INTERVIEW_CATEGORIES_DATA_BEGIN";
export const GET_INTERVIEW_CATEGORIES_DATA_SUCCESS = "GET_INTERVIEW_CATEGORIES_DATA_SUCCESS";
export const GET_INTERVIEW_CATEGORIES_DATA_FAILURE = "GET_INTERVIEW_CATEGORIES_DATA_FAILURE";

export const GET_INTERVIEW_SERIES_DATA_BEGIN = "GET_INTERVIEW_SERIES_DATA_BEGIN";
export const GET_INTERVIEW_SERIES_DATA_SUCCESS = "GET_INTERVIEW_SERIES_DATA_SUCCESS";
export const GET_INTERVIEW_SERIES_DATA_FAILURE = "GET_INTERVIEW_SERIES_DATA_FAILURE";

export const GET_INTERVIEW_QUESTIONS_DATA_BEGIN = "GET_INTERVIEW_QUESTIONS_DATA_BEGIN";
export const GET_INTERVIEW_QUESTIONS_DATA_SUCCESS = "GET_INTERVIEW_QUESTIONS_DATA_SUCCESS";
export const GET_INTERVIEW_QUESTIONS_DATA_FAILURE = "GET_INTERVIEW_QUESTIONS_DATA_FAILURE";

export const GET_USER_INTERACTION_BY_SERIES_BEGIN = "GET_USER_INTERACTION_BY_SERIES_BEGIN";
export const GET_USER_INTERACTION_BY_SERIES_SUCCESS = "GET_USER_INTERACTION_BY_SERIES_SUCCESS";
export const GET_USER_INTERACTION_BY_SERIES_FAILURE = "GET_USER_INTERACTION_BY_SERIES_FAILURE";

export const UPSERT_INTERVIEW_SERIES_USER_INTERACTION_BEGIN = "UPSERT_INTERVIEW_SERIES_USER_INTERACTION_BEGIN";
export const UPSERT_INTERVIEW_SERIES_USER_INTERACTION_SUCCESS = "UPSERT_INTERVIEW_SERIES_USER_INTERACTION_SUCCESS";
export const UPSERT_INTERVIEW_SERIES_USER_INTERACTION_FAILURE = "UPSERT_INTERVIEW_SERIES_USER_INTERACTION_FAILURE";

export const GET_SERIES_INTERACTION_BY_USER_BEGIN = "GET_SERIES_INTERACTION_BY_USER_BEGIN";
export const GET_SERIES_INTERACTION_BY_USER_SUCCESS = "GET_SERIES_INTERACTION_BY_USER_SUCCESS";
export const GET_SERIES_INTERACTION_BY_USER_FAILURE = "GET_SERIES_INTERACTION_BY_USER_FAILURE";

export const GET_TRENDING_INTERVIEW_SERIES_BEGIN = "GET_TRENDING_INTERVIEW_SERIES_BEGIN";
export const GET_TRENDING_INTERVIEW_SERIES_SUCCESS = "GET_TRENDING_INTERVIEW_SERIES_SUCCESS";
export const GET_TRENDING_INTERVIEW_SERIES_FAILURE = "GET_TRENDING_INTERVIEW_SERIES_FAILURE";

// create feedback of series
export const ADD_USER_FEEDBACK_BEGIN = "ADD_USER_FEEDBACK_BEGIN";
export const ADD_USER_FEEDBACK_SUCCESS = "ADD_USER_FEEDBACK_SUCCESS";
export const ADD_USER_FEEDBACK_FAILURE = "ADD_USER_FEEDBACK_FAILURE";

// bug constants
export const CREATE_BUG_BEGIN = "CREATE_BUG_BEGIN";
export const CREATE_BUG_SUCCESS = "CREATE_BUG_SUCCESS";
export const CREATE_BUG_FAILURE = "CREATE_BUG_FAILURE";